export const toAbsoluteUrl = (pathname: string) =>
  process.env.PUBLIC_URL + pathname;

export const toE164PhoneFormatter = (
  value: string,
  countryCode: string = "44"
): string | null => {
  let formattedValue = String(value)
    .trim()
    .replace(/[^\d+]/g, "");

  if (!formattedValue) {
    return null;
  }

  if (formattedValue.startsWith("+")) {
    formattedValue = formattedValue.slice(1);
  }

  formattedValue = formattedValue.replace(/^0+/, "");

  if (!formattedValue) {
    return null;
  }

  if (formattedValue.startsWith(countryCode)) {
    formattedValue = "+" + formattedValue;
  } else {
    formattedValue = "+" + countryCode + formattedValue;
  }

  const phoneNumber = formattedValue.slice(1 + countryCode.length);
  if (phoneNumber.length < 10 || phoneNumber.length > 15) {
    return null;
  }

  // E.164 format check
  if (!/^\+\d+$/.test(formattedValue)) {
    return null;
  }

  // Repeating character check (reject if 7+ same digits in a row)
  if (/(\d)\1{6,}/.test(phoneNumber)) {
    return null;
  }

  return formattedValue;
};

export const toUk07PhoneFormatter = (value: string): string | null => {
  let formattedValue = String(value)
    .trim()
    .replace(/[^\d+]/g, "");

  if (!formattedValue) {
    return null;
  }

  if (formattedValue.startsWith("+")) {
    formattedValue = formattedValue.slice(1);
  }

  if (formattedValue.startsWith("00")) {
    formattedValue = formattedValue.slice(2);
  }

  if (formattedValue.startsWith("44")) {
    formattedValue = "0" + formattedValue.slice(2);
  } else if (formattedValue.startsWith("7")) {
    formattedValue = "0" + formattedValue;
  }

  if (!/^07\d{9}$/.test(formattedValue)) {
    return null;
  }

  const phoneNumber = formattedValue.slice(1);
  if (/(\d)\1{6,}/.test(phoneNumber)) {
    return null;
  }

  return formattedValue;
};

export const getAuthRedirectPath = (): string => {
  const raw = new URLSearchParams(window.location.search).get("redirect");
  if (!raw) return "/dashboard";
  if (raw.startsWith("//")) return "/dashboard";
  return raw.startsWith("/") ? raw : `/${raw}`;
};


export const calculateAge = (dob?: string): number | null => {
  if (!dob) return null;
  const ms = Date.parse(dob);
  if (!Number.isFinite(ms)) return null;
  const d = new Date(ms);
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age--;
  return age >= 0 && age < 130 ? age : null;
};

export const toNumber = (v: unknown): number | null => {
  if (typeof v === "number" && Number.isFinite(v)) return v;
  if (typeof v === "string" && v.trim() !== "" && Number.isFinite(Number(v)))
    return Number(v);
  return null;
};
